/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VersionInfo } from '../../models/version-info';

export interface ApiV0ConfigurationVersionInfoGet$Json$Params {
}

export function apiV0ConfigurationVersionInfoGet$Json(http: HttpClient, rootUrl: string, params?: ApiV0ConfigurationVersionInfoGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<VersionInfo>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConfigurationVersionInfoGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VersionInfo>;
    })
  );
}

apiV0ConfigurationVersionInfoGet$Json.PATH = '/api/v0/configuration/versionInfo';
